import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Fieldset } from 'primereact/fieldset';
import { InputText } from 'primereact/inputtext';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Growl } from 'primereact/growl';
import * as moment from 'moment';
import { BuscaInscricao } from '../../services/inscricao';
import { insereMensalidade } from '../../services/contratos/index';
import FundoAmarelo from '../../assets/fundo_amarelo.png';
import './styles.css';
import { Buscas } from '../../services/dependentes';
import { BuscarAssoc, AtualizarStatus } from '../../services/associados';
import {
    insereAssinatura,
    BuscaAssinat,
    BuscaAceiteUnico
} from '../../services/assinaturas';
import { decriptObjectOnLocalStorage, decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';

const VisualizaAssociado = props => {
    const growl = useRef(null);
    const { inscricao } = props.match.params;
    const vendedor = decriptoLocalStorage('codigo_vendedor')?.decriptoValue;
    const permissao = decriptObjectOnLocalStorage('PERM');
    let coordenador;
    let supervisor;
    const [loading, setLoading] = useState('loading');
    const [ass, setAss] = useState(null);
    const [show, setShow] = useState(false);
    const [sucesso, setSucesso] = useState(false);
    const [erro, setErro] = useState(false);
    const [showCanvas, setShowCanvas] = useState(false);
    const [dependentes, setDependentes] = useState([]);
    const [Associado, setAssociado] = useState([]);
    const sigCanvas = useRef({});
    const [valorDep, setValorDep] = useState([]);
    const [valorInsc, setValorInsc] = useState([]);
    const [pagamentoAde, setPagamentoAde] = useState(false);
    const [valorAdesao, setValorAdesao] = useState([]);
    const [image, setImage] = useState([]);
    const [visibleFullScreen, setVisibleFullScreen] = useState(false);
    const [aceiteUnico, setAceiteUnico] = useState(false);
    const [assValor, setAssValor] = useState(false);

    const [isAdesao, setAdesao] = useState(true);
    const header = <img alt="Card" src={FundoAmarelo} />;
    const [activeIndex] = useState(2);
    const items = [
        { label: 'Associado' },
        { label: 'Dependentes' },
        { label: 'Checkout' }
    ];

    useEffect(() => {
        async function loadAdesao() {
            await BuscaInscricao(inscricao)
                .then(result => {
                    if (result.Pagamento != null) {
                        setPagamentoAde(true);
                    }

                    setValorInsc(result.Valor);
                    setAdesao(false);
                })
                .catch(() => { });
        }

        loadAdesao();
    }, [inscricao]);

    useEffect(() => {
        async function loadAceite() {
            await BuscaAceiteUnico(inscricao)

                .then(result => {
                    if (result.length > 0) {
                        setAceiteUnico(true);
                    }
                })
                .catch(() => { });
        }

        loadAceite();
    }, [inscricao]);

    useEffect(() => {
        let ja = 0;

        async function loadDependentes() {
            const regexValor = '/(\d)(?=(\d{3})+\,)/g'
            await Buscas(`/dependentes/${inscricao}`)
                .then(response => {
                    if (response.length > 0) {
                        for (let i = 0; i < response.length; i++) {
                            response[
                                i
                            ].valorDependente = `${response[i]['CategoriaParentesco.Valor'].toFixed(2).replace('.', ',').replace(regexValor, "$1.")}`;
                            ja += response[i]['CategoriaParentesco.Valor'];
                        }
                    }

                    setValorDep(ja);
                    setDependentes(response);

                    return response;
                })
                .catch(() => { });
        }

        loadDependentes();
    }, [inscricao]);

    useEffect(() => {
        async function loadAssociado() {
            await BuscarAssoc(inscricao)
                .then(response => {
                    setAssociado(response[0]);
                })
                .catch(() => { });
        }

        loadAssociado();
    }, [inscricao]);

    useEffect(() => {
        async function gravaMensalidade() {
            await insereMensalidade(inscricao)
                .then(response => { })
                .catch(error => { });
        }

        gravaMensalidade();
    }, [inscricao]);

    useEffect(() => {
        setValorAdesao(localStorage.getItem('ValorInscricao'));
        localStorage.removeItem('ValorInscricao');
    }, []);

    const save = async ind => {
        setAss(sigCanvas.current.getTrimmedCanvas().toDataURL('image/png'));
        setShow(!show);

        const obj = {
            id_ass_assoc: inscricao,
            ass_b64: ass,
            ass_path: 'n/a'
        };

        if (ind === 2) {
            if (ass.length > 400) {
                setLoading('nada');
                insereAssinatura(inscricao, obj)
                    .then(response => {
                        setLoading('nada');

                        if (response.status === 400) {
                            setLoading('loading');
                            setTimeout(() => {
                                alert(
                                    'ops, estamos tendo problemas para validadr seus dados'
                                );
                            }, 2000);
                        } else if (response.status === 500) {
                            setLoading('loading');
                            setTimeout(() => {
                                alert(
                                    'ops, estamos tendo problemas para validadr seus dados'
                                );
                            }, 2000);
                        }

                        if (response.message === 'sucessufuly') {
                            setSucesso(true);
                            setLoading('loading');
                            setShowCanvas(false);
                            loadAssinatura();
                            window.location.reload();
                        }
                    })
                    .catch(erro => {
                        alert(
                            'ops, estamos tendo problemas para validadr seus dados',
                            erro
                        );
                    });
            } else {
                alert('ops, não detectamos traços suficientes');
                setErro(true);
            }
        }
    };

    const clear = ind => {
        setLoading('loading');
        sigCanvas.current.clear();

        if (ind === 2) {
            save(1);
        }
    };

    const assinatura = () => {
        window.scrollTo(0, 2000);
        setShowCanvas(true);
    };

    async function loadAssinatura() {
        await BuscaAssinat(inscricao)
            .then(response => {
                if (response.ass_b64) {
                    setAssValor(true);
                }

                setImage(response.ass_b64);
            })
            .catch(() => { });
    }

    useEffect(() => {
        loadAssinatura();
    }, [loadAssinatura]);

    const history = useHistory();
    const finalizar = dados => {
        AtualizarStatus(dados, Associado.Status)
            .then(response => {
                if (response.status === 200) {
                    showSuccess('Sucesso! contrato finalizado');
                    setTimeout(() => {
                        history.push('/lista-contratos/');
                    }, 2000);
                } else {
                    showError('Ops! Ocorreu um erro desconhecido');
                }
            })
            .catch(erro => {
                showError('Ops! Erro de servidor');
            });
    };

    const showSuccess = message => {
        growl.current.show({
            severity: 'success',
            summary: '',
            detail: message
        });
    };

    const showError = message => {
        growl.current.show({
            severity: 'error',
            summary: '',
            detail: message
        });
    };

    if (permissao === '7') {
        coordenador = Associado.Coordenador;
        supervisor = Associado.Supervisor;
    }

    if (permissao === '3') {
        coordenador = Associado.Coordenador;
        supervisor = Associado.Supervisor;
    }

    if (permissao === '2') {
        coordenador = Associado.Coordenador;
        supervisor = Associado.Supervisor;
    }

    return (
        <div>
            <Growl ref={growl} />
            <Card className='tratar-scroll-card' header={header} title="Visualizar Associado">
                <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-12 p-lg-12 p-sm-12">
                        <Fieldset legend="Contratante">
                            <div className="p-grid p-fluid">
                                <div className="p-col-12 p-md-12">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Nome"
                                            className="p-col-fixed"
                                            style={{ width: '50px' }}
                                        >
                                            Nome
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                placeholder="Nome"
                                                name="Nome"
                                                id="Nome"
                                                value={Associado.Nome}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Telefone"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Celular
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Celular"
                                                id="Telefone"
                                                value={Associado.Celular}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Email"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Email
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Email"
                                                id="Email"
                                                value={Associado.AssEmail}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Idade"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Nascimento
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Idade"
                                                id="Idade"
                                                value={moment(
                                                    Associado.Nascimento
                                                )
                                                    .add(3, 'hours')
                                                    .format('DD-MM-YYYY')}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Telefone"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Carência
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Carencia"
                                                id="Carencia"
                                                value={moment(
                                                    Associado.CarenFuneral
                                                )
                                                    .add(3, 'hours')
                                                    .format('DD/MM/YYYY')}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Email"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Mensalidade base
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Mensalidade"
                                                id="Mensalidade"
                                                value={new Intl.NumberFormat(
                                                    'pt-BR',
                                                    {
                                                        style: 'currency',
                                                        currency: 'BRL'
                                                    }
                                                ).format(
                                                    Associado['ProdutosPreco.valorBase']
                                                )}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Idade"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Mensalidade total
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Mensalidade"
                                                id="Mensalidade"
                                                value={new Intl.NumberFormat(
                                                    'pt-BR',
                                                    {
                                                        style: 'currency',
                                                        currency: 'BRL'
                                                    }
                                                ).format(
                                                    Associado['ProdutosPreco.valorBase'] +
                                                    valorDep
                                                )}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Idade"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Cod Supervisor
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Supervisor"
                                                id="Supervisor"
                                                value={supervisor}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Telefone"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Cod Coordenador
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Coordenador"
                                                id="Coordenador"
                                                value={coordenador}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Email"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Cod vendedor
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Vendedor"
                                                id="Mensalidade"
                                                value={Associado.Vendedor}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Fieldset>
                        <br />
                        <h2>Dependentes</h2>
                        <br />
                        <DataTable value={dependentes}>
                            <Column field="Nome" header="Nome" />
                            <Column field="Nascimento" header="Nascimento" />
                            <Column field="Parentesco" header="Parentesco" />
                            <Column field="valorDependente" header="Valor" />
                        </DataTable>
                        <br />
                        <br />
                    </div>
                </div>
            </Card>
            <Card title="Assinatura">
                <div className="p-grid p-fluid">
                    <img src={image} style={{ width: '300px' }} alt="img" />
                </div>
            </Card>
        </div>
    );
};

export default VisualizaAssociado;
